/** Fortify Platform Investment Risks v1.0 */

import { GENERAL_INQUIRIES_EMAIL } from "lib/fortifyContact";

export const investmentRisksMeta = {
  company: "FORTIFY PORTAL, INC.",
  title: "Investment Risks",
  lastUpdated: "Last updated: May 21, 2026",
  contactLine: `fortifyportal.ca | ${GENERAL_INQUIRIES_EMAIL}`,
};

export const investmentRisksIntro =
  "Investing in early-stage companies through equity crowdfunding involves a high degree of risk. Before investing on Fortify, you should carefully read and understand all of the risks described below. This is not a complete list of all risks — each offering will also contain specific risk factors in its offering document that you should read carefully.";

export const investmentRisksSections = [
  {
    number: "1",
    title: "Risk of Total Loss",
    paragraphs: [
      "You may lose all of the money you invest. Early-stage and start-up companies have a very high rate of failure. There is no guarantee that any company listed on the Platform will succeed, generate revenue, or return any capital to investors.",
    ],
  },
  {
    number: "2",
    title: "Illiquidity",
    paragraphs: [
      "Securities purchased through the Platform are subject to resale restrictions under applicable Canadian securities laws. There is no public market for these securities, and there is no guarantee that a secondary market will develop. You should be prepared to hold your investment indefinitely and should not invest money you cannot afford to have illiquid for an extended period.",
    ],
  },
  {
    number: "3",
    title: "Dilution",
    paragraphs: [
      "If a company raises additional capital in the future, your percentage ownership in the company may be reduced. Future investors may receive securities with rights or preferences superior to yours, which could reduce the value of your investment.",
    ],
  },
  {
    number: "4",
    title: "No Ongoing Disclosure",
    paragraphs: [
      "Companies that raise funds under NI 45-110 are not subject to the same continuous disclosure obligations as publicly listed companies. After your investment is made, you may receive limited information about the company's performance, financial condition, or material developments.",
    ],
  },
  {
    number: "5",
    title: "Minority Shareholder Limitations",
    paragraphs: [
      "As a minority investor, you will typically have limited rights to influence the management and direction of the company. Founders and major shareholders may make decisions that are not in the best interests of minority investors.",
    ],
  },
  {
    number: "6",
    title: "Business and Operational Risks",
    paragraphs: [
      "Start-up companies face significant challenges including competition, limited operating history, untested products or services, dependence on key personnel, and difficulty accessing additional capital. Many early-stage companies do not survive beyond their first few years of operation.",
    ],
  },
  {
    number: "7",
    title: "Regulatory and Legal Risks",
    paragraphs: [
      "Companies may be subject to regulatory changes that adversely affect their business model. Legal disputes, intellectual property challenges, or regulatory investigations could materially harm a company's prospects.",
    ],
  },
  {
    number: "8",
    title: "Valuation Risk",
    paragraphs: [
      "The valuation of early-stage companies is inherently uncertain and speculative. The price per share set by an issuer in its offering document may not reflect the actual or future value of the company. Independent verification of valuations is not performed by the Platform.",
    ],
  },
  {
    number: "9",
    title: "Platform Risk",
    paragraphs: [
      "Fortify Portal, Inc. operates as a funding portal under NI 45-110 and is not a registered dealer. In the event Fortify Portal, Inc. ceases operations, all subscription funds held in trust will be returned to investors in accordance with the Platform's Refund Policy and NI 45-110.",
    ],
  },
  {
    number: "10",
    title: "Fraud Risk",
    paragraphs: [
      "While the Platform conducts a review of issuers prior to listing, it cannot guarantee the accuracy of all information provided by issuers. There is a risk that issuers may provide false or misleading information. You should conduct your own independent research before investing.",
    ],
  },
  {
    number: "11",
    title: "Acknowledgement",
    paragraphs: [
      "By investing on the Platform, you confirm that you have read and understood the risks described above and in the applicable offering document, and that you are making your investment decision independently and without reliance on any advice from the Platform.",
    ],
  },
];
